
import XImg from 'vux/src/components/x-img/index.vue'

export default {
components: {
XImg
},
props: ['list', 'type']
}



// WEBPACK FOOTER //
// ./src/components/HomeTopNav/MList.vue